import {ExchangePageProps, ExchangePage} from "../../../Components";
import {Project} from "../../../_helpers";

interface Order {
    id: number,
    price: number,
    quantity: number,
    type: string,
    symbol: string,
}
export const MxcConfigPage = () => {
    const props: ExchangePageProps<Order> = {
        getId: (order) => order.id,
        getPrice: (order) => order.price,
        getAmount: (order) => order.quantity,
        isAsk: (order) => order.type === 'ASK',
        getQuoteCurrency: (order) => order.symbol.replace(Project.current.base_currency, ""),
        configFields: {
            "access_key": "Access Key",
            "secret_key": "Secret Key",
        },
        exchange: "mxc",
    }

    return <ExchangePage {...props} />
}
